//src/config/apiConfig.js
export const API_BASE_URL = 'https://lanesands.io/api'; //https://lanesands.io
